import { z } from 'zod'
import {
  abstractComponent,
  COMPONENT_TYPES,
} from '@customTypes/cloudmix/sessions/components/base'
import { v4 as uuidv4 } from 'uuid'
import { audioVideoPadSchema } from '../../pads'

const falseyToUndefined = (val: unknown) => val || undefined

export const zixiSourceComponentSchema = abstractComponent.extend({
  type: z
    .literal(COMPONENT_TYPES.zixiSource)
    .default(COMPONENT_TYPES.zixiSource),
  host: z.string(),
  port: z.preprocess(falseyToUndefined, z.coerce.number().optional()),
  streamId: z.string().min(1).default(''),
  maxLatency: z.preprocess(falseyToUndefined, z.coerce.number().optional()),
  output: audioVideoPadSchema.optional().default(() => {
    const id = uuidv4()
    return { name: id, displayName: id }
  }),
})

export const projectZixiSourceComponentSchema = zixiSourceComponentSchema
export type ProjectZixiSourceComponent = z.infer<
  typeof projectZixiSourceComponentSchema
>
